import { createI18n } from "vue-i18n";
import jaJP from "./locales/ja-JP.json";
import enUS from "./locales/en-US.json";

type MessageSchema = typeof jaJP;

const i18n = createI18n<[MessageSchema], "ja-JP" | "en-US">({
  legacy: false,
  sync: true,
  locale: "ja-JP",
  fallbackLocale: "en-US",
  messages: {
    "ja-JP": jaJP,
    "en-US": enUS,
  }
});

export default i18n;
